import React from "react";
import { Box, Tooltip } from '@mui/material';

export default function StatusMessage(props) {
    const iconStyle = {
        width: '14px',
        height: '14px',
        marginLeft: '4px',
        opacity: 0.8
    };

    if (props.statuses?.status === "sent") {
        return (
            <Tooltip title="Mensaje enviado" arrow placement="top">
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        style={iconStyle}
                        viewBox="0 0 24 24" 
                        strokeWidth="1.5" 
                        stroke="currentColor" 
                        fill="none" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M5 12l5 5l10 -10" />
                    </svg>
                </Box>
            </Tooltip>
        )
    } else if (props.statuses?.status === "delivered") {
        return (
            <Tooltip title="Mensaje entregado al destinatario" arrow placement="top">
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        style={iconStyle}
                        viewBox="0 0 24 24" 
                        strokeWidth="1.5" 
                        stroke="currentColor" 
                        fill="none" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M7 12l5 5l10 -10" />
                        <path d="M2 12l5 5m5 -5l5 -5" />
                    </svg>
                </Box>
            </Tooltip>
        )
    } else if (props.statuses?.status === "failed") {
        let rawDetail = props.statuses?.errors?.[0]?.error_data?.details || props.statuses?.errors?.[0]?.message || props.statuses?.errors?.[0]?.title || "Mensaje no entregable";
        if (rawDetail.toLowerCase().includes("undeliverable")) {
            rawDetail = "Mensaje no entregable";
        }
        const errorCode = props.statuses?.errors?.[0]?.code ? ` (${props.statuses.errors[0].code})` : "";
        return (
            <Tooltip title={`Error en la entrega: ${rawDetail}${errorCode}`} arrow placement="top">
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        style={{ ...iconStyle, color: '#ef4444', opacity: 1 }}
                        viewBox="0 0 24 24" 
                        strokeWidth="2" 
                        stroke="currentColor" 
                        fill="none" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M12 9v4" />
                        <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.268 0z" />
                        <path d="M12 16h.01" />
                    </svg>
                </Box>
            </Tooltip>
        )
    } else if (props.statuses?.status === "read") {
        return (
            <Tooltip title="Mensaje leído por el destinatario" arrow placement="top">
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        style={{ ...iconStyle, color: '#3b82f6', opacity: 1 }}
                        viewBox="0 0 24 24" 
                        strokeWidth="2" 
                        stroke="#3b82f6" 
                        fill="none" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M7 12l5 5l10 -10" />
                        <path d="M2 12l5 5m5 -5l5 -5" />
                    </svg>
                </Box>
            </Tooltip>
        )
    } else {
        return (
            <Tooltip title="Mensaje pendiente de entrega" arrow placement="top">
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        style={iconStyle}
                        viewBox="0 0 24 24" 
                        strokeWidth="1.5" 
                        stroke="currentColor" 
                        fill="none" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                        <path d="M12 7v5l3 3" />
                    </svg>
                </Box>
            </Tooltip>
        )
    }
}